export default __webpack_public_path__ + "static/media/img_15.5a44d979.jpg";